import React, { ReactElement, useContext } from 'react'
import { ArtData } from '@/database/art'
import Button from '@/components/Button'
import { Context } from '@/components/Context'

const ModelButtons = ({ artData, onClose }: { artData: ArtData; onClose: () => void }): ReactElement => {
    const { remove } = useContext(Context)

    return (
        <div className="buttons-container">
            <Button btnName={`Return`} classStyles="nav__button blue" handleClick={onClose} cancelBg={undefined} />
            <Button btnName={`Report`} classStyles="nav__button red" handleClick={undefined} cancelBg={undefined} />
            <Button
                btnName={`Remove`}
                classStyles="nav__button red"
                handleClick={() => remove(artData.art.id)}
                cancelBg={undefined}
            />
        </div>
    )
}

export default ModelButtons
